import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NovaEncomenda from "@/pages/NovaEncomenda";
import Farmacias from "@/pages/Farmacias";
import Encomendas from "@/pages/Encomendas";
import DetalheEncomenda from "@/pages/DetalheEncomenda";
import Produtos from "@/pages/Produtos";
import Relatorios from "@/pages/Relatorios";
import Configuracoes from "@/pages/Configuracoes";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function AppRoutes() {
  const { user } = useAuth();
  
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="nova-encomenda" element={<NovaEncomenda />} />
        <Route path="farmacias" element={<Farmacias />} />
        <Route path="encomendas" element={<Encomendas />} />
        <Route path="encomendas/:id" element={<DetalheEncomenda />} />
        <Route path="produtos" element={<Produtos />} />
        <Route path="relatorios" element={<Relatorios />} />
        <Route path="configuracoes" element={<Configuracoes />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-slate-50">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
